import { ReactNode } from "react";
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";

export function renderReactNodeToHtml(node: ReactNode): string {
  const container = document.createElement("div");
  const root = createRoot(container);

  flushSync(() => {
    root.render(node);
  });

  const html = container.innerHTML;
  root.unmount();
  return html;
}
